export function openSearch() {
    var searchButton = document.querySelector('.vs-search-btn');
    var searchCloseButton = document.querySelector('.search-close');
    var searchDiv = document.querySelector('.vs-search-wrapper');
    var nav = document.querySelector('.vs-main-navigation'); // Navigations-Element

    if (searchButton) {
        searchButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (searchDiv) {
                searchDiv.classList.toggle('active');

                // Überprüfen, ob das Suchfeld aktiv ist
                if (searchDiv.classList.contains('active')) {
                    document.getElementById('s').focus();  // Setzt den Fokus auf das Suchfeld
                    nav && nav.classList.add('onScroll');
                    document.body.style.overflow = 'hidden'; // Scrollen verhindern, wenn das Suchfeld aktiv ist
                } else {
                    if (window.scrollY < 80) {
                        nav && nav.classList.remove('onScroll');
                    }
                    document.body.style.overflow = 'auto'; // Scrollen wieder erlauben, wenn das Suchfeld nicht aktiv ist
                }
            }
        });
    }

    if (searchCloseButton) {
        searchCloseButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (searchDiv) {
                searchDiv.classList.toggle('active');

                // Überprüfen, ob das Suchfeld aktiv ist
                if (searchDiv.classList.contains('active')) {
                    nav && nav.classList.add('onScroll');
                    document.body.style.overflow = 'hidden';
                } else {
                    if (window.scrollY < 80) {
                        nav && nav.classList.remove('onScroll');
                    }
                    document.body.style.overflow = 'auto';
                }
            }
        });
    }


        var searchButton = document.querySelector('.vs-search-btn');
        var targetContainer = document.querySelector('.vs-mobile-search');
        var originalContainer = document.querySelector('.vs-search-menu');

        //console.log('Search Button:', searchButton);
        //console.log('Target Container:', targetContainer);
        //console.log('Original Container:', originalContainer);

        function moveSearchButton() {
          //  console.log('Checking position for moving search button...');
            if (window.innerWidth <= 1052) {
            //    console.log('Viewport is wide enough, moving search button to target container...');
                if (searchButton && targetContainer) {
                    targetContainer.appendChild(searchButton);
              //      console.log('Moved to target container.');
                }
            } else {
                //console.log('Viewport is not wide enough, moving search button back to original container...');
                if (searchButton && originalContainer) {
                    originalContainer.appendChild(searchButton);
                  //  console.log('Moved back to original container.');
                }
            }
        }

        window.addEventListener('resize', moveSearchButton);
        moveSearchButton();

}
